import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map } from 'rxjs';
import { MtvChannelResponse } from 'src/app/pages/foy-tv/foy-tv.module';
import { MCommonListModalRequest, UtilsService } from 'src/app/utils/utils.service';

@Injectable({
  providedIn: 'root'
})
export class WsFoytvService {

  constructor(private httpClient: HttpClient) { }

  /**
* Api to getFoyAll by filters
* @returns 
*/
  getFoyAll(mCommonListModalRequest: MCommonListModalRequest): Observable<MtvChannelResponse> {
    var body = new FormData()
    body.append('take', mCommonListModalRequest.take);
    body.append('skip', mCommonListModalRequest.skip);
    if (mCommonListModalRequest.category_id != null || mCommonListModalRequest.category_id != undefined) {
      body.append('category_id', mCommonListModalRequest.category_id);
    }

    return this.httpClient.post<MtvChannelResponse>(UtilsService.BASE_URL + UtilsService.GETFOYALL, body)
      .pipe(
        map(response => {
          return response;
        }), catchError(UtilsService.ErrorHandler.handleError('getData'))
      )
  }
}
